'use strict'

//
// Theme scripts
//
import './input-mask';

/*------------------------------------------------
    Page Loader
-------------------------------------------------*/
// $(window).on('load', function() {
//     setTimeout(function() {
//         $('.page-loader').fadeOut()
//     }, 300);
// });



// WEBPACK FOOTER //
// ./src/js/login.js